import { History } from 'history';
import { useCallback, useState } from 'react';
import { useHistory, useLocation } from 'react-router';

interface LocationExitPathState {
  exitPath?: string;
}

// 특정 페이지로 이동하는 플로우에서, 탈출경로exitPath를 현재 경로로 하여 라우팅하는 pushWithExitPath, 전달받은 exitPath, exitPath 경로로 복귀하는 backToExitPath 제공합니다.
function useLocationExitPath() {
  const location = useLocation<LocationExitPathState>();
  const history = useHistory();

  // 이 훅을 사용하는 컴포넌트가 마운트 되어 있는 동안에는 경로가 변경되어도 최초 전달받은 exitPath를 유지합니다. (탭 전환 등)
  const [exitPath] = useState(location?.state?.exitPath);

  const currentLocation = `${location.pathname}${location.search}${location.hash}` as string;

  const pushWithExitPath: History<LocationExitPathState>['push'] = useCallback(
    (location, state) => {
      history.push(location, { exitPath: currentLocation, ...state });
    },
    [currentLocation, history]
  );

  const backToExitPath = useCallback(
    ({ fallbackURI }: { fallbackURI: string }) => {
      history.push(exitPath ?? fallbackURI);
    },
    [exitPath, history]
  );

  return { exitPath, pushWithExitPath, backToExitPath };
}

export default useLocationExitPath;
